import { idcMap } from "./idcMap";
import { internmentMap } from "./internment";
import { patientMap } from "./patient";
import { procedureMap } from "./procedure";
import { professionalMap } from "./professional";

export const hospitalizationPermitMap: GenericObject = {
	cid: {
		__key: "icd",
		...idcMap,
	},
	primary_icd_code: "primaryIcdCode",
	secondary_icd_code: "secondaryIcdCode",
	medical_auditor: "medicalAuditor",
	attendance: {
		paciente: {
			__key: "patient",
			...patientMap,
		},
		internament: {
			__key: "internment",
			...internmentMap,
		},
	},
	solicitor: professionalMap,
	procedures: procedureMap,
};
